export default __webpack_public_path__ + "static/media/item-1.37675116.webp";